









































import Vue from 'vue';
import SectionRow from './SectionRow.vue';
import SectionRowMixin from '@/components/section-row/mixins/SectionRowMixin.vue';
import SectionRowItemMixin from '@/components/section-row/mixins/SectionRowItemMixin.vue';
import { CvSectionLink, CvSectionLinkItem } from '@/../gen';

export default Vue.extend({
  components: {
    SectionRow,
  },
  mixins: [SectionRowMixin, SectionRowItemMixin],
  computed: {
    section(): CvSectionLink {
      return this.cvCvSection.section;
    },
    sectionItems(): CvSectionLinkItem[] {
      return this.cvCvSection.sectionItems;
    },
    editLink() {
      return {
        name: 'cv_section_links_edit_path',
        params: { cv_id: this.section.cv_id, id: this.section.id },
      };
    },
    addLink() {
      return {
        name: 'cv_section_link_items_new_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_link_id: this.section.id,
        },
      };
    },
  },
  methods: {
    editItemLink(item: CvSectionLinkItem) {
      return {
        name: 'cv_section_link_items_edit_path',
        params: {
          cv_id: this.section.cv_id,
          cv_section_link_id: this.section.id,
          id: item.id,
        },
      };
    },
  },
});
